export default __webpack_public_path__ + "static/media/LithosPro-Black.37571613.woff";